"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.menoryCache = exports.sessionCache = exports.localCache = void 0;

require("core-js/modules/es6.function.name");

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

require("core-js/modules/es6.regexp.constructor");

var cacheName = 'gaodingx-cache';
var VERSION = '1.0.0';

function getTime(time) {
  if (typeof time === 'number') {
    return time;
  }

  if (typeof time === 'string' && /([.\d]+)([DdSsHhMm])$/.test(time)) {
    var value = +RegExp.$1;

    switch (RegExp.$2.toLocaleLowerCase()) {
      case 'd':
        return value * 24 * 60 * 60 * 1000;

      case 'h':
        return value * 60 * 60 * 1000;

      case 'm':
        return value * 60 * 1000;

      case 's':
        return value * 1000;

      default:
        break;
    }
  }

  throw new Error("\u65E0\u6548\u7684\u65F6\u95F4" + time);
}

function createCache(api) {
  return {
    get(key, options) {
      if (options === void 0) {
        options = {
          version: VERSION,
          time: '7d'
        };
      }

      var _options = options,
          _options$version = _options.version,
          version = _options$version === void 0 ? VERSION : _options$version;

      try {
        var item = api.getItem(cacheName);

        if (item) {
          var root = JSON.parse(item);

          if (root && root.data[key] && root.data[key].version === version) {
            // eslint-disable-line
            if (root.data[key].expires < (0, _now.default)()) {
              this.remove(key);
              return undefined;
            }

            return root.data[key].data;
          }
        }

        return undefined;
      } catch (error) {
        return undefined;
      }
    },

    set(key, data, options) {
      if (options === void 0) {
        options = {
          version: VERSION,
          time: '7d'
        };
      }

      var _options2 = options,
          _options2$version = _options2.version,
          version = _options2$version === void 0 ? VERSION : _options2$version,
          _options2$time = _options2.time,
          time = _options2$time === void 0 ? '7d' : _options2$time;

      try {
        var item = api.getItem(cacheName);

        if (item && item.length > 1024 * 1024 * 3) {
          this.clear();
        }

        var root = item ? JSON.parse(item) : {
          version,
          data: {}
        };
        root.data[key] = {
          version,
          data,
          expires: +new Date() + getTime(time)
        };
        api.setItem(cacheName, (0, _stringify.default)(root));
        return true;
      } catch (error) {
        if (error.name === 'QuotaExceededError') {
          api.removeItem(cacheName);
          return this.set(key, data, options);
        }

        return false;
      }
    },

    clear() {
      try {
        api.removeItem(cacheName);
        return true;
      } catch (error) {
        return false;
      }
    },

    remove(key) {
      try {
        var item = api.getItem(cacheName);

        if (item) {
          var root = JSON.parse(item);
          delete root.data[key];
          return true;
        }

        return false;
      } catch (error) {
        return false;
      }
    }

  };
}

var MenoryStorage =
/*#__PURE__*/
function () {
  function MenoryStorage() {
    this.cache = {};
  }

  var _proto = MenoryStorage.prototype;

  _proto.getItem = function getItem(key) {
    if (key in this.cache) {
      return this.cache[key];
    }

    return null;
  };

  _proto.setItem = function setItem(key, data) {
    this.cache[key] = (0, _stringify.default)(data);
  };

  _proto.removeItem = function removeItem(key) {
    delete this.cache[key];
  };

  return MenoryStorage;
}();

var localCache = createCache(localStorage);
exports.localCache = localCache;
var sessionCache = createCache(sessionStorage);
exports.sessionCache = sessionCache;
var menoryCache = createCache(new MenoryStorage());
exports.menoryCache = menoryCache;